import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

declare var paymill: any;
declare var VALIDATE_CVC: any;

class SubscriptionController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        'store',
        '$filter',
        '$rootScope',
        '$state',
        '$timeout',
        'ArchiSmallServices',
        '$location'
    ];

    constructor(
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private $filter: any,
        private $rootScope: any,
        private $state: any, // ng.IRootScopeService,
        private $timeout: ng.ITimeoutService,
        private ArchiSmallServices: ArchiSmallServices,
        private $location: ng.ILocationService
    ) {
        if (!$scope.$parent.$parent.init()) {
            return;
        }

        $scope.$parent.loadScript('https://bridge.paymill.com/', 'text/javascript', 'utf-8');
        $scope.$parent.loadScript('scripts/paymill/brandDetection.js', 'text/javascript', 'utf-8');
        $scope.$parent.loadScript('scripts/paymill/paymill.js', 'text/javascript', 'utf-8');
        $scope.user = store.get('registeringUser');
        let currentStepName = 'subscription';

        switch ($scope.user.accountData.userType) {
            case 1:
                $scope.pageHeader = 'Registrazione Libero Professionista';
                $scope.pageSubHeader = 'Abbonamento';
                break;
            case 2:
                $scope.pageHeader = 'Registrazione Ditta Individuale';
                $scope.pageSubHeader = 'Abbonamento';
                break;
            case 3:
                $scope.pageHeader = 'Registrazione Azienda';
                $scope.pageSubHeader = 'Abbonamento';
                break;
        }

        $scope.subscriptions = [];
        ArchiSmallServices.getSubscriptions()
            .then((response: any) => {
                for (let index = 0; index < response.length; index++) {
                    $scope.subscriptions.push({
                        code: response[index].id,
                        period: response[index].name,
                        total: response[index].amount / 100,
                        tax: Math.round((((response[index].amount / 100) * 22) / 100) * 100) / 100
                    });
                    if (index === 0 && $scope.user.subscription.subscriptionType === '') {
                        $scope.user.subscription.subscriptionType = response[index].id;
                    }
                }
            }, (error) => {
                $rootScope.alert('error', error);
            });
        $scope.selectedSubscription = (code) => {
            let found = $filter('filter')($scope.subscriptions, { code: code }, true);
            if (found.length) {
                return found[0];
            }
        };
        $scope.currentYear = Number(new Date().getFullYear());
        $scope.prev = () => {
            $scope.user.accountData.lastStepSaved = 'activation-code';
            store.set('registeringUser', $scope.user);
            $state.go('registration.activation-code');
        };
        $scope.errorMessage = '';
        $scope.isDisabled = false;
        let paymillReadResponseTransaction = (response) => {
            try {
                switch (response.status) {
                    case 'closed':
                        $scope.user.paymentResponse = response;
                        $scope.registerUser();
                        break;
                    case 'failed':
                        $timeout(() => {
                            $scope.errorMessage = response.response_code + ' : ' + response.responseCodeDetail;
                            $scope.isDisabled = false;
                        });
                        break;
                    default:
                        $timeout(() => {
                            $scope.errorMessage = 'Unexpected response status : ' + response.status;
                            $scope.isDisabled = false;
                        });
                        break;
                }
            } catch (err) {
                $rootScope.alert('error', err);
                $scope.isDisabled = false;
            }
        };
        let paymillResponseHandler = (error, result) => {
            try {
                if (error) {
                    $timeout(() => {
                        $scope.errorMessage = error.apierror;
                        $scope.isDisabled = false;
                    });
                } else {

                    let transaction = {
                        amount: $scope.selectedSubscription($scope.user.subscription.subscriptionType).total * 100,
                        subscriptionId: $scope.selectedSubscription($scope.user.subscription.subscriptionType).code,
                        transactionDescription: 'transaction Description test',
                        token: result.token,
                        clientEmail: $scope.user.accountData.email,
                        clientDescription: 'client Description test'
                    };
                    ArchiSmallServices.paymentTransaction(transaction)
                        .then((response: any) => {
                            paymillReadResponseTransaction(response);
                        }, (error) => {
                            $rootScope.alert('error', error);
                            $scope.isDisabled = false;
                        });
                }
            } catch (err) {
                $rootScope.alert('error', err);
                $scope.isDisabled = false;
            }
        };
        let paymill_trx_id = $location.search().paymill_trx_id;
        if (paymill_trx_id !== undefined && paymill_trx_id !== '') {
            // case of paypal success callback
            let paypal_trx_id = $location.search().paypal_trx_id;
            //  var paymill_trx_id = $location.search().paymill_trx_id;
            let paymill_trx_status = $location.search().paymill_trx_status;
            let paymill_response_code = $location.search().paymill_response_code;
            let paymill_mode = $location.search().paymill_response_code;
            ArchiSmallServices.validateTransaction(paymill_trx_id)
                .then((response: any) => {
                    switch (response.status) {
                        case 'closed':
                            $scope.user.paymentResponse = response;
                            break;
                        case 'failed':
                            $timeout(() => {
                                $scope.errorMessage = response.response_code + ' : ' + response.responseCodeDetail;
                                $scope.isDisabled = false;
                            });
                            break;
                        case 'pending':
                            $timeout(() => {
                                $scope.errorMessage = response.response_code + ' : ' + response.responseCodeDetail;
                                $scope.isDisabled = false;
                            });
                            break;
                        default:
                            $timeout(() => {
                                $scope.errorMessage = 'Unexpected response status : ' + response.status;
                                $scope.isDisabled = false;
                            });
                            break;
                    }
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        }

        // 5105105105105100 - test year 2020
        $scope.creditCardData = {
            'number': '',
            'exp_month': '',
            'exp_year': '',
            'cvc': '',
            'cardholder': '',
        };
        $scope.next = () => {
            if ($scope.isDisabled) {
                return;
            }
            $scope.isDisabled = true;
            switch ($scope.paymentType) {
                case 'creditCard':
                    $scope.errorMessage = '';
                    if (false === paymill.validateHolder($scope.creditCardData.cardholder)) {
                        $scope.errorMessage = 'invalid-card-holdername';
                        $scope.isDisabled = false;
                        return false;
                    }
                    if ((false === paymill.validateCvc($scope.creditCardData.cvc))) {
                        if (VALIDATE_CVC) {
                            $scope.errorMessage = 'invalid-card-cvc';
                            $scope.isDisabled = false;
                            return false;
                        } else {
                            $('.card-cvc').val('000');
                        }
                    }
                    if (false === paymill.validateCardNumber($scope.creditCardData.number)) {
                        $scope.errorMessage = 'invalid-card-number';
                        $scope.isDisabled = false;
                        return false;
                    }
                    if (false === paymill.validateExpiry($scope.creditCardData.exp_month, $scope.creditCardData.exp_year)) {
                        $scope.errorMessage = 'invalid-card-expiry-date';
                        $scope.isDisabled = false;
                        return false;
                    }

                    let params = {
                        amount_int: Number($scope.selectedSubscription($scope.user.subscription.subscriptionType).total * 100),
                        currency: 'EUR',
                        number: $scope.creditCardData.number,
                        exp_month: $scope.creditCardData.exp_month,
                        exp_year: $scope.creditCardData.exp_year,
                        cvc: $scope.creditCardData.cvc,
                        cardholder: $scope.creditCardData.cardholder
                    };
                    paymill.createToken(params, paymillResponseHandler);
                    break;
                case 'paypal':
                    ArchiSmallServices.paymentChecksum($scope.selectedSubscription($scope.user.subscription.subscriptionType).code)
                        .then((response: any) => {
                            let checksum = response.id;
                            paymill.createTransaction({ checksum: checksum });
                        }, (error) => {
                            $rootScope.alert('error', error);
                        });
                    //                            checksum = 'chk_e668039e9b6eb8569e76a53b7b07';
                    //                            paymill.createTransaction({checksum: checksum});

                    break;
                default:
                    alert('to do..');
                    break;
            }
        };
        $scope.paymentType = 'creditCard';
        $rootScope.formsubmitted = false;
    }
}

export const SubscriptionComponent: ng.IComponentOptions = {
    template: require('./subscription.html'),
    controller: SubscriptionController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/subscription/subscription.ts